<template>
	<div>
		<!-- Page Wrapper -->
		<div id="root">

			<div class="row align-items-stretch">
				<div class="c-dashboardInfo col-lg-3 col-md-6">
					<div class="wrap" style="padding-left: 10px">
						<div class="text-xs font-weight-bold text-primary text-uppercase mb-1">
							Доход (Месячный)
						</div>
						<div class="h5 mb-0 font-weight-bold text-gray-800">
							{{
								sumMonthly | currency({
									symbol: ' ',
									fractionCount: 2,
									symbolPosition: 'back'
								})
							}}
						</div>
					</div>
				</div>
				<div class="c-dashboardInfo col-lg-3 col-md-6">
					<div class="wrap" style="padding-left: 10px">
						<div class="text-xs font-weight-bold text-success text-uppercase mb-1">
							Доход (Вчерашний)
						</div>
						<div class="h5 mb-0 font-weight-bold text-gray-800">
							{{
								sumDaily | currency({
									symbol: ' ',
									fractionCount: 2,
									symbolPosition: 'back'
								})
							}}
						</div>
					</div>
				</div>
				<div class="c-dashboardInfo col-lg-3 col-md-6">
					<div class="wrap" style="padding-left: 10px">
						<div class="text-xs font-weight-bold text-info text-uppercase mb-1">Сумма текущего остатка
						</div>
						<div class="col-auto">
							<div class="h5 mb-0 mr-3 font-weight-bold text-gray-800">
								{{ sumRemaining | currency({ symbol: ' ', fractionCount: 2, symbolPosition: 'back' })
								}}
							</div>
						</div>
					</div>
				</div>
				<div class="c-dashboardInfo col-lg-3 col-md-6">
					<div class="wrap" style="padding-left: 10px">
						<div class="col mr-2">
							<div class="text-xs font-weight-bold text-warning text-uppercase mb-1">
								Сумма вчерашних продаж
							</div>
							<div class="h5 mb-0 font-weight-bold text-gray-800">
								{{ sumSale | currency({ symbol: ' ', fractionCount: 2, symbolPosition: 'back' }) }}
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>
<script>
import ReportService from "../analytics/otchot/report.service";

export default {
	name: 'transaction',
	data() {
		return {
			monthly: [],
			daily: [],
			remaining: [],
			saleSum: []
		}
	},
	computed: {
		sumMonthly() {
			let sum = 0
			this.monthly.forEach(m => {
				sum += m.value
			})
			return sum
		},
		sumDaily() {
			let sum = 0
			this.daily.forEach(d => {
				sum += d.value
			})
			return sum
		},
		sumRemaining() {
			let sum = 0
			this.remaining.forEach(r => {
				sum += r.value
			})
			return sum
		},
		sumSale() {
			let sum = 0
			this.saleSum.forEach(s => {
				sum += s.value
			})
			return sum
		}
	},
	methods: {},
	async created() {
		await ReportService.getDifferentMonthlyReport().then(res => {
			this.monthly = res.data
		}).catch(e => {
		})
		await ReportService.getDifferentDailyReport().then(res => {
			this.daily = res.data
		}).catch(e => {
		})
		await ReportService.getRemainingReport().then(res => {
			this.remaining = res.data
		}).catch(e => {
		})
		await ReportService.dailySaleSum().then(res => {
			this.saleSum = res.data
		})
	}
}
</script>

<style scoped>
.c-dashboardInfo {
	margin-bottom: 15px;
}

.c-dashboardInfo .wrap {
	background: #ffffff;
	box-shadow: 2px 10px 20px rgba(0, 0, 0, 0.1);
	border-radius: 7px;
	position: relative;
	overflow: hidden;
	padding: 18px 5px 5px;
	height: 100%;
}

.c-dashboardInfo__title {
	color: #6c6c6c;
	font-size: 13px;
	font-weight: 900;
	text-align: center;
}

.c-dashboardInfo span {
	display: block;
}

.c-dashboardInfo__count {
	font-weight: bold;
	font-size: 15px;
	color: #323c43;
}

.c-dashboardInfo .wrap:after {
	display: block;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 10px;
	content: "";
}

.c-dashboardInfo:nth-child(1) .wrap:after {
	background: linear-gradient(82.59deg, #00c48c 0%, #00a173 100%);
}

.c-dashboardInfo:nth-child(2) .wrap:after {
	background: linear-gradient(81.67deg, #0084f4 0%, #1a4da2 100%);
}

.c-dashboardInfo:nth-child(3) .wrap:after {
	background: linear-gradient(69.83deg, #0084f4 0%, #00c48c 100%);
}

.c-dashboardInfo:nth-child(4) .wrap:after {
	background: linear-gradient(81.67deg, #ff647c 0%, #1f5dc5 100%);
}

.c-dashboardInfo__title svg {
	color: #d7d7d7;
	margin-left: 5px;
}

.MuiSvgIcon-root-19 {
	fill: currentColor;
	width: 1em;
	height: 1em;
	display: inline-block;
	font-size: 24px;
	transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
	user-select: none;
	flex-shrink: 0;
}
</style>
